angular.module('wbServices').service('accountTypes', ['AccountTypes', (AccountTypes) ->
  @all = AccountTypes.query (result) ->
    result.forEach (r) -> r.categoryCamelCase = _.camelCase(r.category)

  @supported = AccountTypes.query {supported: true}, (result) ->
    result.forEach (r) -> r.categoryCamelCase = _.camelCase(r.category)

  @getByName = (name) ->
    _.find(@all, (candidate) ->
      candidate.name.toLowerCase() == name.toLowerCase()
    )

  @getByType = (type) ->
    _.find(@all, (candidate) ->
      candidate.type.toLowerCase() == type.toLowerCase()
    )

  @
])
